module.exports = __webpack_public_path__ + "img/logo_8.9c04adbc.png";